import { createAction, props } from '@ngrx/store';
import { CommSchemeSetupCreateDto } from '@shared/data-access/dto';
import { CommSchemeSetupModel } from '@shared/data-access/models';

export const setItemDetail = createAction('[Comm Scheme Setup] SET ITEM DETAIL', props<{ item: CommSchemeSetupModel | null }>());

export const updateItemDetail = createAction('[Comm Scheme Setup] UPDATE ITEM DETAIL', props<{ data: Partial<CommSchemeSetupModel> }>());

export const loadItemDetail = createAction('[Comm Scheme Setup] LOAD ITEM DETAIL', props<{ id: number }>());

export const reloadItemDetail = createAction('[Comm Scheme Setup] RELOAD ITEM DETAIL');

export const resetSubmittingStatus = createAction('[Comm Scheme Setup] RESET SUBMITTING STATUS');



